import React from "react";

export const Mind = React.lazy(() => import("@/features/mind/pages/MindPage"));
